import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import WhatsAppLink from "@components/utils/WhatsAppLink";

const FloatingWhatsApp: React.FC = () => {
    return (
        <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[10000]">
            <WhatsAppLink
                className="flex items-center justify-center bg-emerald-600 hover:bg-emerald-700 text-white rounded-full shadow-lg h-12 w-12 transition-colors"
                useLocalPhoneNumber={true}
                aria-label="Chat us on WhatsApp"
            >
                {/* WhatsApp SVG icon */}
                <FontAwesomeIcon
                    icon={faWhatsapp}
                    className="w-6 h-6"
                    style={{ width: "1.75rem", height: "1.75rem" }}
                />
            </WhatsAppLink>
        </div>
    );
};

export default FloatingWhatsApp;
